import * as yup from 'yup';

import { AdjustReason } from 'types/inventory.interface';

export const getAdjustInventorySchema = (adjustReasons: AdjustReason[]) => yup.object().shape({
  selectedReason: yup.string().required('Adjustment reason is required'),
  reasonNote: yup.string().test({
    name: 'noteRequired',
    message: 'Description is required',
    test: (value, context) => {
      const { selectedReason } = context.parent;
      const reason = adjustReasons.find((r) => r.reasonId === selectedReason);
      if (reason?.noteRequired) {
        return !!value?.trim();
      }
      return true;
    },
  }),
  sendToMetrc: yup.boolean(),
});

export const moveInventorySchema = yup.object().shape({
  selectedArea: yup.string().required('Area is required'),
});

export type AdjustInventoryFormData = yup.InferType<ReturnType<typeof getAdjustInventorySchema>>;
export type MoveInventoryFormData = yup.InferType<typeof moveInventorySchema>;
